/* Minha Kidz: Shopify real variant/color selection for product pages and Quick View. */
(() => {
  'use strict';
  const $=(s,root=document)=>root.querySelector(s), $$=(s,root=document)=>Array.from(root.querySelectorAll(s));
  function initProduct(form){
    if(form.dataset.mkVariantReady)return;
    const pickers=$('[data-mk-option-pickers]',form), select=$('[data-variant-select]',form), data=$('[data-mk-product-variants]',form);
    if(!pickers||!select||!data)return;
    let variants=[];try{variants=JSON.parse(data.textContent||'[]')}catch(_){return}
    if(!variants.length)return;
    const groups=$$('[data-mk-option-group]',pickers);
    const current=()=>groups.map(g=>{const active=$('[data-mk-option-choice].is-active',g);return active?.dataset.mkOptionValue||''});
    function selectFromVariant(v){
      if(!v)return;
      groups.forEach((g,index)=>{
        const val=(v.options||[])[index]||'';
        $$('[data-mk-option-choice]',g).forEach(b=>{
          const yes=b.dataset.mkOptionValue===val;
          b.classList.toggle('is-active',yes);b.setAttribute('aria-pressed',String(yes));
        });
        const displayed=$('[data-mk-current-option]',g);if(displayed)displayed.textContent=val;
      });
      if(select.value!==String(v.id)){select.value=String(v.id);select.dispatchEvent(new Event('change',{bubbles:true}))}
    }
    function refreshAvailability(){
      const chosen=current();
      groups.forEach((g,i)=>$$('[data-mk-option-choice]',g).forEach(b=>{
        const availableSomewhere=variants.some(v=>v.available&&(v.options||[])[i]===b.dataset.mkOptionValue);
        const availableTogether=variants.some(v=>v.available&&(v.options||[]).every((o,j)=>j===i?o===b.dataset.mkOptionValue:o===chosen[j]));
        b.disabled=!availableSomewhere;
        b.classList.toggle('mk-combination-unavailable', availableSomewhere&&!availableTogether);
        b.setAttribute('aria-disabled',String(!availableSomewhere));
      }));
    }
    pickers.addEventListener('click',e=>{
      const b=e.target.closest('[data-mk-option-choice]');if(!b||b.disabled)return;
      const g=b.closest('[data-mk-option-group]');const idx=Number(g.dataset.mkOptionIndex);
      const chosen=current();chosen[idx]=b.dataset.mkOptionValue;
      // Find the actual matching Shopify variant, not a color-only fake selection.
      const direct=variants.find(v=>(v.options||[]).every((value,i)=>value===chosen[i]));
      const variant=(direct?.available?direct:null)||variants.find(v=>v.available&&(v.options||[])[idx]===chosen[idx])||direct||variants.find(v=>(v.options||[])[idx]===chosen[idx]);
      if(!variant)return;
      selectFromVariant(variant);refreshAvailability();
      // Update the main product photo, without jumping the page when the color changes.
      const gallery=form.closest('.product-editorial')?.querySelector('.product-gallery-editorial');
      const hero=gallery?.querySelector('.product-gallery-editorial__item img');
      if(hero){
        if(!hero.dataset.mkBaseSrc){hero.dataset.mkBaseSrc=hero.src;hero.dataset.mkBaseSrcset=hero.getAttribute('srcset')||'';}
        const variantPhoto=variant.featured_image?.src || variant.featured_media?.preview_image?.src;
        if(variantPhoto){hero.src=variantPhoto.startsWith('//')?'https:'+variantPhoto:variantPhoto;hero.removeAttribute('srcset');hero.alt=(hero.alt||'Product image')+' — '+variant.title;}
        else{hero.src=hero.dataset.mkBaseSrc;if(hero.dataset.mkBaseSrcset)hero.setAttribute('srcset',hero.dataset.mkBaseSrcset)}
      }
    });
    select.addEventListener('change',()=>{
      const v=variants.find(v=>String(v.id)===select.value);
      if(v){selectFromVariant(v);refreshAvailability()}
    });
    const first=variants.find(v=>String(v.id)===select.value)||variants[0];
    selectFromVariant(first);refreshAvailability();
    form.dataset.mkVariantReady='1';
    const fallback=select.closest('.mk-variant-fallback');if(fallback)fallback.classList.add('mk-is-enhanced');
  }
  document.addEventListener('DOMContentLoaded',()=>{
    $$('[data-product-form]').forEach(initProduct);
  });
  document.addEventListener('shopify:section:load',e=>$$('[data-product-form]',e.target).forEach(initProduct));
})();
